import React from "react";
import {useSelector} from "../../../shared-services/redux-tiny";

const BottomDrawer = (props) => {
  const {name, children, className = "", style} = props;
  const {bottomDrawer} = useSelector(state => state.topLayer);

  return <>
    {children && bottomDrawer?.name === name && <div
      className={`
        bottom-drawer
        full-width
        background-color-white
        z-index-top-layer
        soft-revert-shadow
        ${className}`}
      style={{
        ...style
      }}
    >
      {children}
    </div>}
  </>;
};

export default BottomDrawer;
